module.exports = __webpack_public_path__ + "media/images/fbcalls/4-0828ce68b67dab4d463a27d236bf3227.png";